<template>
  <input
    class="date-input"
    v-model="formattedDate"
    @input="onInput"
    @blur="onBlur"
    placeholder="дд.мм.гггг"
  />
</template>

<script>
import { ref, watch } from "vue";

export default {
  name: "DateInput",
  setup(_,{emit}) {
    const date = ref(null);
    const formattedDate = ref("");

    const onInput = () => {
      // Формируем форматированную строку даты с точками
      const inputDate = formattedDate.value.replace(/\D/g, "");
      const day = inputDate.substring(0, 2);
      const month = inputDate.substring(2, 4);
      const year = inputDate.substring(4, 8);

      // Проверяем наличие всех частей даты и присваиваем значение переменной date
      if (day.length === 2 && month.length === 2 && year.length === 4) {
        date.value = `${day}.${month}.${year}`;
        emit('value',date.value)
      } else {
        date.value = null;
      }
    };

    const onBlur = () => {
      // Форматируем дату при потере фокуса
      if (date.value) {
        const [day, month, year] = date.value.split(".");
        formattedDate.value = `${day}.${month}.${year}`;
      }
    };

    // Watch for changes in the date value and update the formattedDate accordingly
    watch(date, (newVal) => {
      if (newVal) {
        const [day, month, year] = newVal.split(".");
        formattedDate.value = `${day}.${month}.${year}`;
      }
    });

    return {
      formattedDate,
      onInput,
      onBlur,
    };
  },
};
</script>

<style>
.date-input {
  width: 330px;
  padding: 8px 10px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
  outline: none;
  transition: border-color 0.2s ease-in-out;
}

.date-input:focus {
  border-color: #007bff;
}
</style>
